import { FC, memo, Dispatch, SetStateAction } from 'react'

import { FilterGroupHeader } from 'components'
import MetadatasForm from './components/MetadatasForm'
import MetadatasValues from './components/MetadatasValues'

type Props = {
  title: string
  description: string
  metadata: any
  metadanaFieldName?: string
  values: any
  setValues: Dispatch<SetStateAction<any>>
}

const FilterGroupForMetadatas: FC<Props> = ({ title, description, values, metadata, setValues }) => {
  if (!metadata?.id) return null

  return (
    <FilterGroupHeader
      title={title}
      description={description}
      contentWhenAccordionIsClose={<MetadatasValues values={values} metadata={metadata} />}
      content={<MetadatasForm metadata={metadata} values={values} setValues={setValues} />}
    />
  )
}

export default memo(FilterGroupForMetadatas)
